import { combineResolvers, resolveIndividual } from "@helium/anchor-resolvers";
import { PROGRAM_ID } from "./constants";
import { init } from "./init";
import { proposalKey } from "./pdas";
export const organizationsProgramResolver = resolveIndividual(async ({ path }) => {
    if (path[path.length - 1] === "organizationProgram") {
        return PROGRAM_ID;
    }
});
export const organizationsResolvers = combineResolvers(organizationsProgramResolver, resolveIndividual(async ({ path, accounts, provider, programId }) => {
    if (path[path.length - 1] === "proposal" && accounts.organization) {
        const program = await init(provider, programId);
        const org = await program.account.organizationV0.fetch(accounts.organization);
        return proposalKey(accounts.organization, org.numProposals)[0];
    }
    else if (path[path.length - 1] === "proposalConfig") {
        const program = await init(provider, programId);
        const org = await program.account.organizationV0.fetch(accounts.organization);
        return org.defaultProposalConfig;
    }
    else if (path[path.length - 1] == "owner") {
        if (provider.wallet) {
            return provider.wallet.publicKey;
        }
    }
}));
//# sourceMappingURL=resolvers.js.map